var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTimer = function SvgTimer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "timer_FILL0_wght400_GRAD0_opsz20",
    d: "M147.857,169.273V168h4.286v1.273Zm1.5,7.636h1.286v-4.242h-1.286ZM150,182a5.846,5.846,0,0,1-2.338-.469,6.111,6.111,0,0,1-1.9-1.274,6.043,6.043,0,0,1-1.287-1.882,5.894,5.894,0,0,1,0-4.628,6.043,6.043,0,0,1,1.287-1.882,6.111,6.111,0,0,1,1.9-1.274,6,6,0,0,1,4.327-.124,6.735,6.735,0,0,1,1.778.963l.929-.9.893.884-.911.919a6.334,6.334,0,0,1,.973,1.747,5.861,5.861,0,0,1-.125,4.3,6.044,6.044,0,0,1-1.287,1.882,6.111,6.111,0,0,1-1.9,1.274A5.846,5.846,0,0,1,150,182Zm0-1.273a4.57,4.57,0,0,0,3.339-1.361,4.661,4.661,0,0,0,0-6.611,4.777,4.777,0,0,0-6.679,0,4.661,4.661,0,0,0,0,6.611A4.57,4.57,0,0,0,150,180.727ZM150,176.061Z",
    transform: "translate(-144 -168)",
    fill: "var(--hyperlink )"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timer.3763aa33.svg";
export { ForwardRef as ReactComponent };